export default __webpack_public_path__ + "static/media/exterior-4.4483992e.webp";